import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Storage } from '@angular/fire/storage';
import { GlobalStoreService } from '@principle-theorem/ng-principle-shared';
import {
  type IMedia,
  PatientMediaSize,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { ReplaySubject } from 'rxjs';
import { MediaDisplayItem } from '../../media-display-item';

@Component({
  selector: 'pr-media-list-item',
  templateUrl: './media-list-item.component.html',
  styleUrls: ['./media-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MediaListItemComponent extends MediaDisplayItem {
  size$ = new ReplaySubject<PatientMediaSize>(1);

  @Input()
  set media(media: WithRef<IMedia>) {
    if (media) {
      this.media$.next(media);
      this.namedDocsToTags.namedDocs$.next(media.tags);
    }
  }

  @Input()
  set size(size: PatientMediaSize) {
    if (size) {
      this.size$.next(size);
    }
  }

  constructor(storage: Storage, global: GlobalStoreService) {
    super(storage, global);
  }
}
